/* 27/09/2026, chantier « scores côté serveur » (décision d'Hicham).
 *
 * POURQUOI. Le lecteur calculait les scores dans le navigateur, à partir des
 * bonnes réponses qu'il recevait (responses[].points, isValid, success, fail,
 * glbMasterPond). Un candidat THE SCAN pouvait donc les lire et fabriquer son
 * score. Pour lui, le serveur calcule désormais, et ne lui envoie plus les
 * bonnes réponses avant qu'il ait répondu.
 *
 * ⛔ LE FRONT PART EN LIGNE AVANT LE NOUVEAU SERVEUR. Avec l'ancien serveur, le
 * candidat reçoit encore tout, et la route /formation/sequence/repondre
 * n'existe pas : le lecteur doit alors se comporter exactement comme avant. On
 * ne devine donc pas la version du serveur : on regarde ce qu'il a envoyé.
 *
 * LE SIGNAL : la clé `glbMasterPond` sur la formation. L'ancien serveur la
 * sélectionne toujours, même nulle (models/formation.js getByUserId et
 * models/content.js getOneByIdAsync, étiquette lab-2026-09-26-01, les deux
 * chemins du candidat dans getAllInfos) ; le nouveau la retire pour un
 * candidat. C'est une clé du MODULE : elle ne dépend d'aucun contenu. Un signal
 * pris sur un écran seul (« aucune réponse ne porte isValid ») se tromperait
 * sur un quiz dont le contenu n'a jamais eu cette clé, et bloquerait alors le
 * candidat sur une route absente. Pour un quiz, on exige donc LES DEUX : module
 * sans glbMasterPond ET écran sans isValid.
 *
 * Apprenants THE LAB, admins, essai « Tester le module », aperçu admin : le
 * compte n'est pas `theScanCandidat`, rien ne change pour eux. */
import { getCurrentUser } from "./auth"

const porteLaCle = (objet, cle) =>
  !!objet && typeof objet === "object" && Object.prototype.hasOwnProperty.call(objet, cle)

export const estCandidatScan = () => getCurrentUser()?.type === "theScanCandidat"

/* Vrai quand le serveur calcule les scores de ce candidat : c'est alors au
   serveur, et à lui seul, de noter, de calculer le bilan et le resultFin. */
export const scoresCalculesParLeServeur = (formation) =>
  estCandidatScan() && !!formation && typeof formation === "object" && !porteLaCle(formation, "glbMasterPond")

/* Vrai quand la correction de CET écran de quiz doit être demandée au serveur :
   il n'a pas livré les bonnes réponses. */
export const correctionDemandeeAuServeur = (formation, format) =>
  scoresCalculesParLeServeur(formation) && !(format?.responses || []).some((r) => porteLaCle(r, "isValid"))

/* 27/09/2026 (relecture) : les deux fonctions suivantes vivaient dans
   FormatQuizz. Elles ne dependent d'aucun etat de l'ecran : elles sont ici,
   avec la regle, et se testent seules. */

/* Une reponse du serveur n'est exploitable que si elle porte une
   correction ecran par ecran, dans l'ordre des propositions, et le choix
   qu'il a enregistre. Un corps d'une autre forme (route absente, page
   d'erreur) est un echec : on ne colore pas l'ecran au hasard. */
export const correctionExploitable = (reponse, cible) => {
  if (!reponse || (reponse.error && reponse.dejaRepondu !== true)) return false
  const c = reponse.correction
  if (!c || !Array.isArray(c.reponses) || c.reponses.length !== (cible?.responses?.length || 0)) return false
  if (![0, 1, true, false].includes(c.userIsValid)) return false
  return Array.isArray(reponse.userChoice) && reponse.userChoice.every((i) => Number.isInteger(i))
}

/* La correction recue est posee SUR L'ECRAN, comme le serveur la rend pour un
   ecran deja fait au rechargement : l'affichage juste/faux (couleurs, bloc
   d'explication) reste celui d'avant, il lit les memes champs (PD-10 : la
   correction apres chaque quiz est gardee).
   Ces cles ne repartent pas au serveur, mais seulement parce que le serveur
   les SUPPRIME de l'ecran pas encore fait (contrat du 27/09/2026) :
   saveUserFormation n'envoie que les valeurs REMPLACEES, et une cle absente
   qui apparait est un ajout, pas un remplacement. Si le serveur les envoyait
   a null, elles repartiraient vers saveResult ; le serveur les y ecarterait
   (liste blanche CHAMPS_METIER, lue dans lab-2026-09-26-01), sans dommage mais
   pour rien. */
export const poserCorrection = (cible, c) => {
  (cible?.responses || []).forEach((r, i) => {
    const v = c.reponses[i]?.isValid
    r.isValid = v === true || v === 1
  })
  if (c.success !== undefined) cible.success = c.success
  if (c.fail !== undefined) cible.fail = c.fail
}
